import {
  all,
  call,
  cancelled,
  put,
  takeEvery,
} from 'redux-saga/effects';
import {
  FETCH_CANCEL,
  FETCH_END,
  FETCH_ERROR,
  FETCH_START,
} from '../actions/fetchActions';

import log from '../../log';

export function* handleFetch(dataProvider, authProvider, action) {
  if (!dataProvider) {
    log.error('No Data Provider provided to fetch saga');
    return null;
  }

  let response;
  const {
    type,
    payload,
    meta: {
      fetch: fetchMeta, onSuccess, onFailure, ...meta
    },
    resolve,
    reject
  } = action;
  const restType = fetchMeta;
  try {
    yield all([
      put({ type: FETCH_START, meta }),
    ]);

    // Call the data provider
    response = yield call(
      dataProvider,
      restType,
      meta.resource,
      payload,
      meta,
      authProvider,
    );
    yield put({
      type: `${type}_SUCCESS`,
      payload: response,
      requestPayload: payload,
      meta: {
        ...meta,
        ...onSuccess,
        fetchResponse: restType,
        fetchStatus: FETCH_END,
      },
    });

    yield put({ type: FETCH_END, meta });

    if (resolve) {
      resolve(response);
    }
  } catch (error) {
    log.debug('raise error', error);
    // NOTE this should only dispatch the failure and error. Any other logic should be handled elsewhere
    yield put({
      type: `${type}_FAILURE`,
      error: error.message ? error.message : error,
      payload: error.body ? error.body : null,
      requestPayload: payload,
      meta: {
        ...meta,
        ...onFailure,
        fetchResponse: restType,
        fetchStatus: FETCH_ERROR,
      },
    });
    yield put({ type: FETCH_ERROR, error, meta });

    if (reject) {
      reject(error);
    }
  } finally {
    if (yield cancelled()) {
      yield put({ type: FETCH_CANCEL, meta });
    }
  }
  return response;
}

export const takeFetchAction = (action) => action.meta && action.meta.fetch;

const fetch = (dataProvider, authProvider) => function* watchFetch() {
  yield takeEvery(takeFetchAction, handleFetch, dataProvider, authProvider);
};

export default fetch;
